import React from "react";
import { TabList, Tab } from "@headlessui/react";

const CustomCheckIcon = () => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="0.5" y="0.5" width="25" height="25" rx="12.5" fill="#DD097D" />
		<rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="#DD097D" />
		<path d="M11.8918 17.2363L18.7487 10.0365C19.0838 9.6846 19.0838 9.11581 18.7487 8.76392C18.4135 8.41203 17.8718 8.41203 17.5367 8.76392L11.2858 15.3275L8.4633 12.3638C8.12817 12.0119 7.58648 12.0119 7.25135 12.3638C6.91622 12.7157 6.91622 13.2845 7.25135 13.6364L10.6798 17.2363C10.8469 17.4118 11.0664 17.5 11.2858 17.5C11.5052 17.5 11.7246 17.4118 11.8918 17.2363Z" fill="#FAFAFA" />
	</svg>
);

const CustomNumberIcon = ({ index, isActive }) => (
	<div
		className={`w-[26px] h-[26px] p-1 rounded-[50px] border flex justify-center items-center ${isActive ? "border-ipxon-white text-ipxon-white border-dashed" : "border-ipxon-medium-dark-gray text-ipxon-medium-dark-gray"
			}`}
	>
		<div className="text-sm leading-[18px]">{index + 1}</div>
	</div>
);

const TabNavigation = ({ tabs, currentTab, setCurrentTab }) => (
	<TabList className="flex">
		{tabs.map((tab, index) => {
			let Icon;
			if (index < currentTab || (index === 2 && currentTab === 2)) {
				Icon = <CustomCheckIcon />;
			} else {
				Icon = <CustomNumberIcon index={index} isActive={index === currentTab} />;
			}

			return (
				<Tab
					key={index}
					as="div"
					onClick={() => {
						const isConfirmationReached = currentTab === 2;
						if (!isConfirmationReached && index <= currentTab) {
							setCurrentTab(index);
						}
					}}
					className={({ selected }) => {
						const isConfirmationTab = currentTab === 2;
						const isOtherTab = index !== currentTab;
						return `
							flex flex-grow items-center gap-4 justify-center border-b transition-all duration-300 pb-4
							${selected ? "!border-b-ipxon-magenta" : "border-b-ipxon-medium-dark-gray"}
							${currentTab === 2 && index !== 2 ? "pointer-events-none opacity-50 cursor-not-allowed" : "cursor-pointer"}
						`;
					}}
				>
					{({ selected }) => (
						<div className={`flex flex-col md:flex-row items-center gap-2 md:gap-4
										${index < 2 ? "w-full justify-center border-r border-ipxon-light-blue-gray" : ""}`}
						>
							{Icon}
							<div className="flex flex-col gap-0.5 text-start">
								<p className={`text-sm font-bold ${selected ? "text-ipxon-white" : "text-ipxon-medium-dark-gray"} ${index < currentTab ? "!text-ipxon-white" : ""}`}>
									{tab.title}
								</p>
								<p className={`text-xs hidden md:block ${selected ? "text-ipxon-white" : "text-ipxon-medium-dark-gray"} ${index < currentTab ? "!text-ipxon-white" : ""}`}>
									{tab.description}
								</p>
							</div>
						</div>
					)}
				</Tab>
			);
		})}
	</TabList>
);

export default TabNavigation;
